import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "database-modal-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "database-modal__heading" }, " Add asset to database ", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "database-modal__text" }, " You are adding an asset to the database. Would you like to add tags to the image? ", -1 /* HOISTED */)
const _hoisted_4 = { class: "grid flex flex--wrap flex--justify-space-between" }
const _hoisted_5 = { class: "grid__item a6-12 f6-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", { class: "database-modal__sub-heading" }, " Common tags ", -1 /* HOISTED */)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = {
  key: 1,
  class: "mb-32"
}
const _hoisted_9 = { class: "form__set mb-16" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  for: "new_tag",
  class: "form__label"
}, " Enter a tag ", -1 /* HOISTED */)
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = {
  key: 2,
  class: "error-message"
}
const _hoisted_14 = { class: "grid__item a6-12 f6-6" }
const _hoisted_15 = ["src", "alt"]
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "database-modal__buttons" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h2", { class: "database-modal__heading" }, " Are you sure you want to remove this asset from the database? ", -1 /* HOISTED */)
const _hoisted_19 = { class: "database-modal__buttons" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["database-modal", { 'database-modal--narrow': $props.mode === 'remove' }])
    }, [
      _createElementVNode("button", {
        class: "database-modal__close",
        "aria-label": "Close modal",
        onClick: _cache[0] || (_cache[0] = (...args) => ($options.closeModal && $options.closeModal(...args)))
      }),
      _createElementVNode("div", {
        class: _normalizeClass(["database-modal__content", { 'database-modal__content--loading': $data.loading }])
      }, [
        ($props.mode === 'add')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _hoisted_2,
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  ($options.filtered_common_tags.length)
                    ? (_openBlock(), _createBlock(_TransitionGroup, {
                        key: 0,
                        name: "grid",
                        tag: "ul",
                        class: "tags mb-32"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.filtered_common_tags, (tag) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: tag.id,
                              class: "tags__tag tags__tag--selectable",
                              onClick: $event => ($options.addTag( tag.title ))
                            }, _toDisplayString(tag.title), 9 /* TEXT, PROPS */, _hoisted_7))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : (_openBlock(), _createElementBlock("p", _hoisted_8, " No common tags found. ")),
                  _createElementVNode("div", _hoisted_9, [
                    _hoisted_10,
                    _withDirectives(_createElementVNode("input", {
                      id: "new_tag",
                      ref: "new-tag-input",
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => (($data.new_tag) = $event)),
                      class: "form__input form__input--lowercase",
                      type: "text",
                      name: "new_tag",
                      disabled: $data.loading,
                      onKeyup: _cache[2] || (_cache[2] = _withKeys((...args) => ($options.submitNewTag && $options.submitNewTag(...args)), ["enter"]))
                    }, null, 40 /* PROPS, HYDRATE_EVENTS */, _hoisted_11), [
                      [_vModelText, $data.new_tag]
                    ])
                  ]),
                  _createElementVNode("button", {
                    class: _normalizeClass(["button mb-16", { 'button--loading': $data.loading }]),
                    disabled: !$data.new_tag || $data.loading,
                    onClick: _cache[3] || (_cache[3] = (...args) => ($options.submitNewTag && $options.submitNewTag(...args)))
                  }, " Create tag ", 10 /* CLASS, PROPS */, _hoisted_12),
                  ($data.error_message)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString($data.error_message), 1 /* TEXT */))
                    : _createCommentVNode("v-if", true)
                ]),
                _createElementVNode("div", _hoisted_14, [
                  ($props.option.image_small_url || $props.option.thumbnail_url)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: $props.option.id,
                        class: "database-modal__image",
                        src: $props.option.image_small_url || $props.option.thumbnail_url,
                        alt: $props.option.title
                      }, null, 8 /* PROPS */, _hoisted_15))
                    : _createCommentVNode("v-if", true),
                  _createVNode(_TransitionGroup, {
                    name: "grid",
                    tag: "ul",
                    class: "tags"
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.option.database_tags, (tag) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: tag.id,
                          class: "tags__tag tags__tag--selected"
                        }, [
                          _createTextVNode(_toDisplayString(tag.title) + " ", 1 /* TEXT */),
                          _createElementVNode("button", {
                            class: "tags__remove-tag",
                            onClick: $event => ($options.removeTag( tag.id ))
                          }, null, 8 /* PROPS */, _hoisted_16)
                        ]))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("button", {
                  class: "database-modal__cancel",
                  onClick: _cache[4] || (_cache[4] = (...args) => ($options.closeModal && $options.closeModal(...args)))
                }, " Cancel "),
                _createElementVNode("button", {
                  class: "database-modal__confirm",
                  onClick: _cache[5] || (_cache[5] = (...args) => ($options.addImageToDatabase && $options.addImageToDatabase(...args)))
                }, " Add asset to database ")
              ])
            ], 64 /* STABLE_FRAGMENT */))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("button", {
                  class: "database-modal__cancel",
                  onClick: _cache[6] || (_cache[6] = (...args) => ($options.closeModal && $options.closeModal(...args)))
                }, " Cancel "),
                _createElementVNode("button", {
                  class: "database-modal__confirm",
                  onClick: _cache[7] || (_cache[7] = $event => (_ctx.$emit( 'confirm' )))
                }, " Remove ")
              ])
            ], 64 /* STABLE_FRAGMENT */))
      ], 2 /* CLASS */)
    ], 2 /* CLASS */)
  ]))
}